import Humanitix from "@/components/humanitix/humanitix-iframe";
import {
  LandingSection,
  LandingSectionContent,
  LandingSectionHeader,
  type LandingSectionProps,
  LandingSectionTitle,
} from "@/components/landing-page/landing-page-section";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { splitProps } from "solid-js";

export function RegistrationSection(props: LandingSectionProps) {
  const [local, rest] = splitProps(props, ["class"]);

  return (
    <LandingSection class={cn("", local.class)} {...rest}>
      <LandingSectionHeader>
        <LandingSectionTitle>Register</LandingSectionTitle>
      </LandingSectionHeader>

      <LandingSectionContent>
        <Card class="flex h-full w-full flex-col border-border p-0">
          <CardHeader class="flex flex-reverse flex-col">
            <CardDescription class="font-semibold text-base text-muted-foreground/65 uppercase md:text-xl">
              Register
            </CardDescription>
            <CardTitle class="text-xl md:text-3xl">
              <span>Ready to join us?</span>
            </CardTitle>
          </CardHeader>
          <Separator class="border-border" />
          <CardContent class="flex h-full grow flex-col items-stretch justify-between gap-4 bg-geometric pt-6 md:gap-12 lg:flex-row lg:gap-18">
            <Humanitix />
          </CardContent>
        </Card>
      </LandingSectionContent>
    </LandingSection>
  );
}
